import { ConnectionRight } from '@shared/interfaces/nts/connection-right';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import { TableConfig } from '@shared/interfaces/table/table-config';

const commonColumns: TableConfig<ConnectionRight>['columns'] = [
  {
    title: 'connectionRight.validFrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'connectionRight.validTo',
    key: 'validTo',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'connectionRight.comment',
    key: 'comment',
  },
  {
    title: 'connectionRight.changedBy',
    key: 'modifiedBy',
  },
];

export const connectionRightHistoryTable: TableConfig<ConnectionRight> = {
  pagination: false,
  columnSelection: false,
  resize: false,
  disableSorting: true,
  columns: [
    {
      title: 'connectionRight.maximumPower',
      key: 'maximumPower',
      cellRenderer: DecimalCellComponent,
    },
    {
      title: 'connectionRight.maximumCurrent',
      key: 'maximumCurrent',
      cellRenderer: DecimalCellComponent,
    },
    {
      title: 'connectionRight.limitedGridAccess',
      key: 'limitedGridAccess',
      cellRenderer: DecimalCellComponent,
    },
    {
      title: 'connectionRight.limitedGridAccessCurrent',
      key: 'limitedGridAccessCurrent',
      cellRenderer: DecimalCellComponent,
    },
    ...commonColumns,
  ],
};
